// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3452":"aa3e1905","6314":"aa3e1905","8019":"82502e99"}[chunkId] + ".chunk.css";
};